import {
  Box,
  Container,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { StudioPage } from '../../../page-templates/StudioPage';
import * as styles from './Analytics.styles';
import { ArtistsTable } from './ArtistsTable';
import { CollectionsTable } from './CollectionsTable';
import { TracksTable } from './TracksTable';

export const Analytics = () => {
  const [timePeriod, setTimePeriod] = useState('current-month');

  const handleTimePeriodChange = (event: SelectChangeEvent<string>) => {
    setTimePeriod(event.target.value);
  };

  return (
    <StudioPage>
      {/* Header */}
      <Box component="header" sx={styles.headerContainer}>
        <Typography
          variant="h4"
          color="text.primary"
          sx={styles.headerTitle}
        >
          Analytics
        </Typography>
      </Box>

      <Container maxWidth={false} sx={styles.mainContainer}>
        <CollectionsTable
          timePeriod={timePeriod}
          onTimePeriodChange={handleTimePeriodChange}
        />
        <TracksTable
          timePeriod={timePeriod}
          onTimePeriodChange={handleTimePeriodChange}
        />
        <ArtistsTable
          timePeriod={timePeriod}
          onTimePeriodChange={handleTimePeriodChange}
        />
      </Container>
    </StudioPage>
  );
};

